// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CodePreview_wrapper__2hNPE"};